import request from '@/utils/request'

/**
 *工单管理-分页列表
 * @param {*} data 
 */
export function demandList(data){
    return request({
        url: '/demand/list',
        method: 'post',
        data
    })
}

/**
 *获取工单
 * @param {*} data 
 */
export function agreementInfo(data){
    return request({
        url: '/agree/agreementInfo',
        method: 'post',
        data
    })
}
/**
 *创建工单须知
 * @param {*} data 
 */
export function add(data){
    return request({
        url: '/agree/add',
        method: 'post',
        data
    })
}
/**
 *工单管理-查看
 * @param {*} data 
 */
export function check(data){
    return request({
        url: '/demand/check',
        method: 'post',
        data
    })
}
/**
 *工单管理-修改
 * @param {*} data 
 */
export function update(data){
    return request({
        url: '/demand/update',
        method: 'post',
        data
    })
}

/**
 *派工单反馈
 * @param {*} data 
 */
export function demandFeedback(data){
    return request({
        url: '/web/demand/add',
        method: 'post',
        data
    })
}


/**
 *派工单反馈列表
 * @param {*} data 
 */
export function demandFeedbackList(data){
    return request({
        url: '/web/demand/demandFeedbackList',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/workOrder.js